import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import registerServiceWorker from './registerServiceWorker';
import App from './App.js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure({
  //position: toast.POSITION.BOTTOM_LEFT
})

window.fbAsyncInit = () => {
  window.FB.init({
    appId: process.env.REACT_APP_FB_APP_ID,
    cookie: true,
    xfbml: true,
    version: process.env.REACT_APP_FACEBOOK_APP_VERSION ? process.env.REACT_APP_FACEBOOK_APP_VERSION : 'v5.0'
  });
};

(function (d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

const rootEl = document.getElementById('root');

const render = (Component) => {
  ReactDOM.render(
    <App Component={Component} />,
    rootEl
  );
};

render(Routes);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js